import * as React from 'react';

import {
  Lang,
  Colors,

  Title,
  Text,
} from '@bluecurrent/web-component-lib';

import Setup from '../../../config/Setup.config';

import Skeleton from '../../Modules/Skeleton';

export default function Legal(props) {
  const { i18n } = Lang.useTranslation();

  const lang = Setup.PSEUDO ? Setup.FALLBACK_LANG : i18n.language;

  const [data, setData] = React.useState({});
  const [isLoading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (props.data !== undefined) {
      setData(props.data);
      setLoading(false);
    }
  }, [props.data]);

  return (
    <>
      {
        isLoading ? (
          <Skeleton
            height={40}
            width="100%"
          />
        ) : (
          <Title>{data.title[lang]}</Title>
        )
      }
      <div
        style={{
          marginTop: 10,
          marginBottom: 30,
        }}
      >
        {
          isLoading ? (
            <Skeleton
              height={25}
              width={200}
            />
          ) : (
            <Text
              fontSize="1em"
              color={Colors.DARK_GREY}
            >
              {data.version}
            </Text>
          )
        }
      </div>
      {
        isLoading ? (
          [...Array(5)].map((index) => (
            <Skeleton
              key={index}
              height={25}
              width="100%"
              count={3}
            />
          ))
        ) : (
          <Text
            portableText
          >
            {data.content[lang]}
          </Text>
        )
      }
    </>
  );
}
